var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"td-clear"},[_c('el-button',{on:{"click":_vm.btnClear}},[_vm._v("清除缓存")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.btnTo}},[_vm._v("进入添丁")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-001c4bdf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/clear.vue
// module id = null
// module chunks = 